import React, { Component } from 'react';
import Card from '../components/Card';

class Education extends Component {
    render() {
        return (
            <div className="condiv">
            <h1 className="subtopic">Education Background</h1>
            <Card title="Telecommunication Engineering (Bachelor)" where="ITB (Bandung Institute of Technology)" from="2017" to="2021"/>

            <h1 className="subtopic">License & Certification</h1>
            <Card title="Huawei Certified ICT Associate AI" where="Huawei" from="2020" to="2023"/>
            <Card title="Huawei Certified ICT Associate Cloud Computing" where="Huawei" from="2020" to="2023"/>
            <Card title="Huawei Certified ICT Associate Routing & Switching" where="Huawei" from="2019" to="2022"/>
            </div>
            )
        }
    }
    
export default Education